// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"00ead562","166":"786b1115"}[chunkId] + ".chunk.js";
};